<button [id]="componentId" [type]="type" [class]="inlineClasses + ' ' + inputClass" [disabled]="disabled || state === ASYNC_BUTTON_STATE.SENDING" (click)="onButtonClick($event)">
  <ng-content></ng-content>
  <fa-icon *ngIf="icon" [icon]="icon" class="mr-3"></fa-icon>
  <span>{{ state === ASYNC_BUTTON_STATE.IDLE ? label : loadingLabel }} </span>
  <fa-icon class="ml-3" *ngIf="state === ASYNC_BUTTON_STATE.SENDING" [icon]="faSpinner" [spin]="true"></fa-icon>
</button>
